import React, { Component } from 'react';
import { Spin } from 'antd';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Router from './Router';
import NavBar from './NavBar';
import Footer from './Footer';
import BackToTop from './BackToTop';
import { loadApplicationRequest } from './appActions';

import '../styles/main.scss';

export class PageWrapper extends Component {
  componentDidMount() {
    this.props.loadApplicationRequest();
  }

  render() {
    const { app } = this.props;
    const { hasLoaded } = app;

    return (
      <div>
        <NavBar
          app={app}
        />
        {hasLoaded && (
          <Router />
        )}
        {!hasLoaded && (
          <div
            id="loadingApp"
            className="card-container align-center"
            style={{ padding: 120 }}
          >
            <Spin size="large" />
          </div>
        )}
        <Footer />
        <BackToTop />
      </div>
    );
  }
}

PageWrapper.propTypes = {
  app: PropTypes.shape({
    hasLoaded: PropTypes.bool.isRequired,
    userName: PropTypes.string.isRequired,
  }).isRequired,
  loadApplicationRequest: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  app: state.app,
});

const mapDispatchToProps = dispatch => bindActionCreators(
  {
    loadApplicationRequest,
  },
  dispatch,
);

export default connect(mapStateToProps, mapDispatchToProps)(PageWrapper);
